<template>
  <div>
    <FITModal ref="deleteProductModal" reference="modal" :title="$t('osm.product.delete.header')" @click="onClickModalDelete">
      <div slot="body">
        <span v-html="$t('osm.product.delete.confirmDelete', {productCode: clickedRow.productCode, productChineseName: clickedRow.productChineseName, productEnglishName: clickedRow.productEnglishName})"></span>
      </div>
    </FITModal>
    <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>{{$t('osm.product.list.header')}}</h4>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-button variant="primary" size="md" @click="createProduct"><i class="fa fa-plus-circle mr-2"></i>{{ $t('osm.product.create.header') }}</b-button>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" :filters="filters" :actions="actions" vuexModule="Product" searchAction="getProductList" type="product" :columns="columns"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITSearchableTable, FITFormCard, FITAlert, FITModal, FITAutoSearch } from '@/components'
import { mapGetters } from 'vuex';
export default {
  name: 'ProductList',
  props: {
    alertContent: {
      type: String,
      default: null
    },
    alertVariant: {
      type: String,
      default: null
    }
  },
  mounted() {
    if (this.alertContent) {
      this.setAlert();
      this.$refs.alert.showAlert();
    }
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
  },
  methods: {
    getTranslated(type, key) {

      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Product', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
    setAlert() {
      if (this.alertContent) {
        Vue.set(this.alertParams, 'content', this.alertContent);
      }
      if (this.alertVariant) {
        Vue.set(this.alertParams, 'variant', this.alertVariant);
      }
    },
    createProduct() {
      this.$router.push({
        name: 'Create Product'
      })
    },
    onRowSelected(val) {
      this.$router.push({
        name: 'Create Product',
        params: { detail: val, productHeader: this.$t('general.CURD.edit') }
      });
    },
    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('Product/deleteProduct', this.clickedRow.ID).then((json) => {
        this.$refs.table.search({ page: 1, count: 25 });
        this.$refs.deleteProductModal.closeModal();
        Vue.set(this, 'alertParams', { content: this.$t('general.deleteSuccess'), variant: 'success' });
        this.$refs.alert.showAlert();
      })
    },
  },
  data() {
    return {
      clickedRow: {
        productCode: 'N/A',
        productEnglishName: 'N/A',
        productChineseName: 'N/A'
      },
      alertParams: {
        content: '<strong>Success</strong>',
        variant: 'success'
      },
      columns: [
        { key: 'productCode', label: this.$t('osm.product.productCode'), sortable: true, },
        {
          key: 'providerID',
          label: this.$t('osm.provider.header'),
          sortable: true,
          formatter: (row, key, item) => {
            return item.providerEnglishName + "</br>" + item.providerChineseName;
          }
        },
        {
          key: 'productEnglishName',
          label: this.$t('osm.product.productName'),
          sortable: true,
          formatter: (row, key, item) => {
            return item.productEnglishName + "</br>" + item.productChineseName;
          }
        },
        {
          key: 'productType',
          label: this.$t('osm.product.productType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        { key: 'updateTime', label: this.$t('osm.product.list.updateTime'), sortable: true },
      ],
      actions: [{
          text: this.$t('general.CURD.edit'),
          key: 'edit',
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            this.$router.push({
              name: 'Create Product',
              params: { detail: row, productHeader: this.$t('osm.product.edit.header') }
            });
          }
        },
        {
          text: this.$t('general.CURD.delete'),
          key: 'delete',
          callback: (key, row, instance) => {
            Vue.set(this, 'clickedRow', row);
            this.$refs.deleteProductModal.openModal();
          },
          class: 'text-danger'
        }
      ],
      filters: [{
        label: this.$t('osm.product.productType'),
        key: 'productType',
        type: 'select',
        default: null,
      }],
    }
  },
  components: {
    FITSearchableTable,
    FITFormCard,
    FITAlert,
    FITModal,
    FITAutoSearch
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/Product/containers/ProductList.vue